/**
 * Copyright © 2022 Anagog Ltd. All rights reserved.
 */

export enum JedAIStatus {
	passive = "passive",
	active = "active",
	unknown = "unknown" // used for errors only
}